import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 0D7E150C-A65F-4A77-86A4-B0F5F2B60347
 * name tally-mark-5
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tally-mark-5.svg
 * tags
 * - Math 
 */
export const TallyMark5Icon = createSvgIcon(<><path d="M19 10.73V19H17V11.36L15 12V19H13V12.62L11 13.26V19H9V13.89L7 14.5V19H5V15.15L2.57 15.92L2 14L5 13.05V5H7V12.42L9 11.79V5H11V11.16L13 10.53V5H15V9.9L17 9.26V5H19V8.63L21 8L21.57 9.92L19 10.73Z" /></>, 'TallyMark5Icon');
export default TallyMark5Icon